import { HomesItinerary, HomesItineraryResponse, MyTripsFilter } from "redmond";
import { call, put, select } from "redux-saga/effects";
import { fetchHomes } from "../../../api/v1/itinerary/fetchHomes";
import { actions } from "../actions";
import { setUpMyTripsParams } from "./setUpTripsParams";
import { getHomes } from "../reducer";

export function* fetchHomesSaga(action: actions.IFetchHomes) {
  try {
    const homesItinerariesResponse: HomesItineraryResponse = yield fetchHomes(
      action.request
    );

    const { tripId } = yield call(setUpMyTripsParams, action);
    const existingHomes: { [key: string]: HomesItinerary[] } =
      yield select(getHomes);
    const {
      future = [...existingHomes.future],
      canceled = [...existingHomes.canceled],
      past = [...existingHomes.past],
      present = [...existingHomes.present],
    } = homesItinerariesResponse.itineraries;
    let selectedHomeFilter: MyTripsFilter | null = null;
    let selectedHome = [...future, ...present].find(
      (home: HomesItinerary) =>
        home.reservation.id.value === tripId ||
        home.reservation.cartOrderedProductId === tripId
    );

    if (!selectedHome) {
      const canceledHome = canceled.find(
        (home: HomesItinerary) =>
          home.reservation.id.value === tripId ||
          home.reservation.cartOrderedProductId === tripId
      );
      if (canceledHome) {
        selectedHome = canceledHome;
        selectedHomeFilter = MyTripsFilter.CANCELED_TRIPS;
      } else {
        const pastHome = past.find(
          (home: HomesItinerary) =>
            home.reservation.id.value === tripId ||
            home.reservation.cartOrderedProductId === tripId
        );
        if (pastHome) {
          selectedHome = pastHome;
          selectedHomeFilter = MyTripsFilter.PAST_TRIPS;
        }
      }
    }

    if (selectedHomeFilter) {
      yield put(actions.setTripsFilter(selectedHomeFilter));
      yield put(actions.populateTripQueryParams(action.history, { tripId }));
    }
    if (selectedHome) {
      yield put(
        actions.setSelectedHome({
          ...selectedHome,
        })
      );
    }
    yield put(
      actions.setHomes(
        {
          present,
          canceled,
          past,
          future,
        },
        action.request.states
      )
    );
  } catch (e) {
    yield put(actions.fetchHomesFailed(action.request));
    console.error(e);
  }
}
